/**
 *  Node Element
 *    - selectors reusability
 *    - closest ( selector )
 *    - on ( action, callback )               (alias, for addEventListener)
 *    - off ( action, callback )              (alias, for removeEventListener)
 *    - delegate ( action, target, callback ) (event delegation)
 *    - classNameToggle (className, condition)
 */


// CUBE Helpers reusability
Node.prototype.$      = function $ (selector)       { return this.querySelector(selector); };
Node.prototype.$$     = function $$ (selector)      { return this.querySelectorAll(selector); };
Node.prototype.$class = function $class (className) { return this.getElementsByClassName(className); };
Node.prototype.$tag   = function $tag (tagName)     { return this.getElementsByTagName(tagName); };
// Warning ! ids and names are unique. getElementById and getElementsByName methods are only present in document object


Node.prototype.$id = function $id (id) {
  return this.querySelector(`#${ id }`);
};

Node.prototype.$name = function $name (name) {
  return this.querySelector(`[name=${ name }]`);
};


/**
 * Node.matches polyfill
 *
 * @param {String} selector
 * @return {Boolean}
 */
if (!Element.prototype.matches)
  Element.prototype.matches = Element.prototype.msMatchesSelector;


/* Node.closest ( selector )
 * return the closest matching parent or null
 */
if (!Node.prototype.closest) {
  Node.prototype.closest = function closest (selector) {
    let element = this;

    if (!document.documentElement.contains(element))
      return null;

    do {
      if (element.matches(selector))
        return element;

      element = element.parentElement || element.parentNode;
    } while (element !== null && element.nodeType === 1);

    return null;
  };
}


// Node.on ( action, callback )
if (!Node.prototype.on) {
  Node.prototype.on = Node.prototype.addEventListener;
}

// Node.off ( action, callback )
if (!Node.prototype.off) {
  Node.prototype.off = Node.prototype.removeEventListener;
}

/* Node.delegate( event, target, callback)
 * Delegate an event on specific childs of element
 */
if (!Node.prototype.delegate) {
  Node.prototype.delegate = function delegate (eventName, target, callback) {
    this.on(eventName, event => {
      let item = event.target;

      while (item && (typeof item.matches !== 'function' || !item.matches(target))) {
        item = item.parentNode;
      };

      if (item && item.matches(target)) {
        callback(event);
      }
    });
  };
}



/* Toggle a className from a condition
 * If the condition is true, the class is added, else, it is removed
 */
Node.prototype.classNameToggle = function classNameToggle (className, condition) {
  if (condition)  this.classList.add(className);
  else            this.classList.remove(className);
};



// WEBPACK FOOTER //
// ./src/modules-es5/commons/polyfills/node-element.js